import BaseService from './base.service';

export default class AccessLogService {
    static ENDPOINT = '/access-logs';

    static async getPhotoId(logId) {
        const endpoint = `${this.ENDPOINT}/${logId}/photo-id`;
        return BaseService.get(endpoint);
    }

    // Signed URL (1 minute) for the plate capture of an LPR log linked to `lpr_attempts`;
    // null when the read had no image. Requested on demand, never cached.
    static async getLprImageUrl(logId) {
        const endpoint = `${this.ENDPOINT}/${logId}/lpr-image-url`;
        return BaseService.get(endpoint);
    }
}
